import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
  } from 'redux-saga/effects';
  import { sidebarService } from '../services';
  import { sidebarAction as actions } from '../actions';


   /* Get Sidebar */
   function* handleGetSidebarRequest() {
    const action = yield take(actions.getSidebarRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
      res = yield call(sidebarService.getSidebar);
      if (res.isError) {
        yield put(actions.getSidebarError(res));
        
      } else {
        yield put(actions.getSidebarSuccess(res));
      }

    } catch (error) {
      yield put(actions.getSidebarError());
    }
  }

    // -----------Watchers-------------
    function* handleGetSidebarWatcher() {
        yield takeEvery(
          actions.getSidebarRequest,
          handleGetSidebarRequest,
        );
      }
      

      
  function* rootSidebarSaga() {
    yield all([
        handleGetSidebarRequest(),
        handleGetSidebarWatcher(),
    ]);
  }
  
  export default rootSidebarSaga;
